import { render, staticRenderFns } from "./ModulesListItem.vue?vue&type=template&id=67d5d882&scoped=true&"
import script from "./ModulesListItem.vue?vue&type=script&lang=js&"
export * from "./ModulesListItem.vue?vue&type=script&lang=js&"
import style0 from "./ModulesListItem.vue?vue&type=style&index=0&id=67d5d882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5d882",
  null
  
)

export default component.exports